import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { HistoryProps } from 'src/constants/Interface';
import { connectRouter } from 'connected-react-router';

import { adminReducer, adminSagas, AdminState } from './admin';
import { userReducer, userSagas, UserState } from './user';
import { masterReducer, masterSagas, MasterState } from './master';
import { shopReducer, shopSagas, ShopState } from './shop';
import { notificationReducer, notificationSagas, NotificationState } from './notification';
import {
  notificationTemplateReducer,
  notificationTemplateSagas,
  NotificationTemplateState,
} from './notificationTemplate';
import { orderBreadReducer, orderBreadSagas, OrderBreadState } from './orderBread';
import { orderReducer, orderSagas, OrderState } from './order';
import { orderItemReducer, orderItemSagas, OrderItemState } from './orderItem';
import { bakedBreadReducer, bakedBreadSagas, BakedBreadState } from './bakedBread';
import { bakedBreadTagReducer, bakedBreadTagSagas, BakedBreadTagState } from './bakedBreadTag';
import { revenueReducer, revenueSagas, RevenueState } from './revenue';

export type State = {
  admin: AdminState;
  user: UserState;
  master: MasterState;
  shop: ShopState;
  notification: NotificationState;
  notificationTemplate: NotificationTemplateState;
  orderBread: OrderBreadState;
  order: OrderState;
  orderItem: OrderItemState;
  bakedBread: BakedBreadState;
  bakedBreadTag: BakedBreadTagState;
  revenue: RevenueState;
};

export const createRootReducers = (history: HistoryProps['history']) =>
  combineReducers({
    router: connectRouter(history),
    admin: adminReducer,
    user: userReducer,
    shop: shopReducer,
    master: masterReducer,
    notification: notificationReducer,
    notificationTemplate: notificationTemplateReducer,
    orderBread: orderBreadReducer,
    order: orderReducer,
    orderItem: orderItemReducer,
    bakedBread: bakedBreadReducer,
    bakedBreadTag: bakedBreadTagReducer,
    revenue: revenueReducer,
  });

export function* rootSagas() {
  yield all([
    ...adminSagas,
    ...userSagas,
    ...shopSagas,
    ...masterSagas,
    ...notificationSagas,
    ...notificationTemplateSagas,
    ...orderBreadSagas,
    ...orderSagas,
    ...orderItemSagas,
    ...bakedBreadSagas,
    ...bakedBreadTagSagas,
    ...revenueSagas,
  ]);
}
